import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SqlGeneratorComponent } from './sql-generator.component';
import { XgsGuardGuard } from 'app/auth/auth-guards/xgs-guard.guard';
import { AuthGuard } from 'app/auth/auth-guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: SqlGeneratorComponent,
    pathMatch: 'full',
    canActivate: [XgsGuardGuard, AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SqlGeneratorRoutingModule { }
